import { customInstance } from '@/features/auth/axios-config'
import {
  RequestCreateDatasetVersion,
  RequestFilters,
  RequestUpdateDatasetVersion,
  SuccessResponseListBool,
  SuccessResponseResponseDatasetVersion,
} from '@/schema'
import { mergeTablePaginationParams } from '@/utils'

const API_ENDPOINT_DATASET_VERSIONS = '/admin/v1/dataset-versions'
const buildApiById = (id: string) => `${API_ENDPOINT_DATASET_VERSIONS}/${id}`

export const datasetVersionApi = {
  /**
   * Fetches a list of dataset versions
   * @param data - Filter and pagination data
   * @returns Promise with dataset version list data and pagination info
   */
  getDatasetVersionList: async (
    data: Partial<RequestFilters> = {}
  ): Promise<SuccessResponseResponseDatasetVersion> => {
    const requestBody = mergeTablePaginationParams(data)

    return customInstance<SuccessResponseResponseDatasetVersion>({
      method: 'post',
      url: `${API_ENDPOINT_DATASET_VERSIONS}/list`,
      data: requestBody,
    })
  },
  /**
   * Fetches a dataset version by ID
   * @param id - Dataset version ID
   * @returns Promise with dataset version data
   */
  getDatasetVersionById: async (
    id: string
  ): Promise<SuccessResponseResponseDatasetVersion> => {
    return customInstance<SuccessResponseResponseDatasetVersion>({
      method: 'get',
      url: buildApiById(id),
    })
  },
  /**
   * Creates a new dataset version
   * @param data - Dataset version data
   * @returns Promise with created dataset version data
   */
  createDatasetVersion: async (
    data: RequestCreateDatasetVersion
  ): Promise<SuccessResponseResponseDatasetVersion> => {
    return customInstance<SuccessResponseResponseDatasetVersion>({
      method: 'post',
      url: API_ENDPOINT_DATASET_VERSIONS,
      data,
    })
  },
  /**
   * Updates an existing dataset version
   * @param id - Dataset version ID
   * @param data - Updated dataset version data
   * @returns Promise with updated dataset version data
   */
  updateDatasetVersion: async (
    id: string,
    data: RequestUpdateDatasetVersion
  ): Promise<SuccessResponseResponseDatasetVersion> => {
    return customInstance<SuccessResponseResponseDatasetVersion>({
      method: 'put',
      url: buildApiById(id),
      data,
    })
  },
  /**
   * Deletes a dataset version
   * @param id - Dataset version ID
   * @returns Promise with deletion confirmation
   */
  deleteDatasetVersion: async (
    id: string
  ): Promise<SuccessResponseListBool> => {
    return customInstance<SuccessResponseListBool>({
      method: 'delete',
      url: buildApiById(id),
    })
  },
}
